export const theme = {
  colors: {
    background: '#F2F9FF',
    surface: '#FFFFFF',
    text: '#3F5D6B',
    textStrong: '#2D3F48',
    muted: '#636363',
    primary: '#0B86F6',
    primaryHover: '#0671D4',
    primarySoft: '#E3F1FE',
    accent: '#0284F5',
    navy: '#0B2A3C',
    highlight: '#FFE45C',
    border: '#E4E4E4',
    success: '#20804E',
    successBg: '#D9F2E5',
    warning: '#B26A00',
    warningBg: '#FFF1D6',
    danger: '#C23737',
    dangerBg: '#FDE8E8',
  },
  fonts: {
    sans: 'Montserrat, ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
    display: 'Montserrat Alternates, Montserrat, ui-sans-serif, system-ui, sans-serif',
  },
  radius: {
    sm: '8px',
    md: '12px',
    lg: '20px',
  },
  shadow: '0 12px 30px rgba(23, 32, 51, 0.08)',
  sectionPadding: 'max(32px, calc((100vw - 1200px) / 2))',
  breakpoints: {
    mobile: '640px',
  },
} as const

export type AppTheme = typeof theme
